(ns frontend.view.nev.screening-profile.view
  (:require
   [common.localization :as loc]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.loading-spinner.view :as loading-spinner]
   [ui.components.modal.view :as modal]
   [ui.data.view-entities.event :as view-entities-event]
   [ui.data.view-entities.sub :as view-entities-sub]
   [ui.view.screening.sub :as screening-sub]
   [ui.view.screening.screening-profile-info-table.view :as screening-profile-info-table]))

(def view-id [:screening-profile :main])
(def scope-id :entity-scope)

(defn- parse-id
  [v]
  (cond
    (number? v) v
    (string? v) (let [parsed (js/parseInt v 10)]
                  (when-not (js/isNaN parsed)
                    parsed))
    :else nil))

(defn- page-content
  [screening-profile-id]
  (let [screening-profile @(rf/subscribe [::view-entities-sub/scope-root-entity view-id scope-id])
        {:keys [loading? error]} @(rf/subscribe [::view-entities-sub/scope-status view-id scope-id])
        ;; Pass this NEV's own view-id/scope-id through so these subs read
        ;; the scope-local entity graph (:screening-profile/kyc-profiles and
        ;; the kyc-profiles/counterparty-diligences it points at) that was
        ;; actually fetched here, instead of the global session cache these
        ;; subs otherwise default to for their other caller, the legacy
        ;; screening grid (see ai/mistakes.md).
        kyc-profiles-and-pep-statuses @(rf/subscribe [::screening-sub/kyc-profiles-and-pep-statuses screening-profile-id view-id scope-id])
        counterparty-diligences-and-pep-statuses @(rf/subscribe [::screening-sub/counterparty-diligences-and-pep-statuses screening-profile-id view-id scope-id])
        pep-or-rca-mismatch-data @(rf/subscribe [::screening-sub/pep-or-rca-mismatch-data screening-profile-id view-id scope-id])
        counterparty-diligence-access? (session/counterparty-diligence-admin?)]
    (js/console.log "SCREENING-NEV: render state"
                    (clj->js {:screening-profile-id screening-profile-id
                              :loading? loading?
                              :error error
                              :entity-present? (some? screening-profile)}))
    (cond
      screening-profile
      [:div {:class "p-4"}
       [modal/view
        {:visible? true
         :hide!    #(routing/set-view! [:screening])}
        [:p (loc/tr :entity.type/screening-profile)]
        [screening-profile-info-table/view
         {:screening-profile                        screening-profile
          :show-kyc-data?                           true
          :show-counterparty-diligence-data?        counterparty-diligence-access?
          :pep-or-rca-mismatch-data                 pep-or-rca-mismatch-data
          :kyc-profiles-and-pep-statuses            kyc-profiles-and-pep-statuses
          :counterparty-diligences-and-pep-statuses counterparty-diligences-and-pep-statuses}]]]

      loading?
      [:div {:class "p-6 text-base-light-text-paler flex items-center"}
       [loading-spinner/circle]
       [:span (loc/tr :loading)]]

      (some? error)
      [:div {:class "p-6 text-red-600"}
       [:p "Unable to load screening profile data."]
       [:p {:class "mt-2 text-sm text-base-light-text-paler"} (str error)]]

      :else
      [:div {:class "p-6 text-base-light-text-paler flex items-center"}
       [loading-spinner/circle]
       [:span (loc/tr :loading)]])))

(defn- root-view
  [screening-profile-id]
  (r/create-class
   {:component-did-mount
    (fn [_]
      (js/console.log "SCREENING-NEV: root mount" screening-profile-id)
      (rf/dispatch [::view-entities-event/open-view-entity-scope
                    {:view-id view-id
                     :scope-id scope-id
                     :entity-id screening-profile-id
                     :instance-id :nev-screening-profile-view}]))
    :component-did-update
    (fn [_ _]
      (js/console.log "SCREENING-NEV: root update" screening-profile-id))
    :component-will-unmount
    (fn [_]
      (js/console.log "SCREENING-NEV: root unmount" screening-profile-id)
      (rf/dispatch [::view-entities-event/close-view-entity-scope
                    {:view-id view-id
                     :scope-id scope-id
                     :entity-id screening-profile-id
                     :instance-id :nev-screening-profile-view}]))
    :reagent-render
    (fn [_]
      [page-content screening-profile-id])}))

(defmethod routing/render-view :entity.type/screening-profile
  [{:keys [route-params]}]
  (let [screening-profile-id (parse-id (:id route-params))]
    [default-page-layout/view
     [root-view screening-profile-id]]))
